document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".section").forEach((section) => {
    const id = section.id.replace("shopify-", "");
    let paddingElement = section.querySelector(`.${id}-padding`) ?? section;
    const styles = window.getComputedStyle(paddingElement);
    const paddingTop = parseInt(styles.getPropertyValue("padding-top"));
    const paddingBottom = parseInt(styles.getPropertyValue("padding-bottom"));
    section.dataset.top = paddingTop;
    section.dataset.bottom = paddingBottom;
  });

  const backgroundEffects = document.querySelectorAll(".background-effect");

  backgroundEffects.forEach((item) => {
    changePadding(item);
  });

  window.addEventListener("resize", function () {
    backgroundEffects.forEach((item) => {
      changePadding(item);
    });
  });

  function changePadding(item) {
    const directionTop = item.classList.contains("top");
    const parentSection = item.closest("section");
    const appliedSection = directionTop
      ? parentSection.previousElementSibling
      : parentSection.nextElementSibling;

    if (appliedSection) {
      const id = appliedSection.id.replace("shopify-", "");
      let paddingElement =
        appliedSection.querySelector(`.${id}-padding`) ?? appliedSection;

      if (directionTop) {
        const oldPadding = appliedSection.dataset.bottom;
        paddingElement.style.paddingBottom = `${
          (oldPadding ? parseInt(oldPadding) : 0) + item.clientHeight
        }px`;
      } else {
        const oldPadding = appliedSection.dataset.top;
        paddingElement.style.paddingTop = `${
          (oldPadding ? parseInt(oldPadding) : 0) + item.clientHeight
        }px`;
      }
    }
  }
});
